import { render, staticRenderFns } from "./headerManage.vue?vue&type=template&id=9fa250da&scoped=true&"
import script from "./headerManage.vue?vue&type=script&lang=js&"
export * from "./headerManage.vue?vue&type=script&lang=js&"
import style0 from "./headerManage.vue?vue&type=style&index=0&id=9fa250da&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9fa250da",
  null
  
)

export default component.exports